import styled from 'styled-components';

export const StyledMenuNav = styled.div`
  .nav-link {
    width: 100%;
    display: flex !important;
    position: relative;
    box-sizing: border-box;
    text-align: left;
    align-items: center;
    justify-content: flex-start;
  }
  .nav-item {
    display: block !important;
  }
`;

